import { Integration, Reservation, ServerIntegration, ServerIntegrationSend, ServerReservation } from "../_modelsTS/Integration";

export class IntegrationMapper {
    static allServerToLocal(serverIntegrations: ServerIntegration[]) {
        return serverIntegrations.map(this.serverToLocal);
    }

    static serverToLocal({
        company, 
        name,
        template_uid,
        template_name,
        owner,
        invitation_group, 
        link, 
        create_public_url, 
        uid,
        created_on,
        modified_on,
        last_reservations_checked,
        can_force_sync,
        sync_status,
        sync_error,
        last_sync_at,
        apikey_is_valid,
        has_api_secret,
        host_id,
        apikey,
        hotel_id,
        host_name,
        room_id,
        room_name,
        check_in,
        check_out,
        username,
        send_invitation_url,
        send_invitation_url_from_pms,
        days_for_invitation_create,
        }: ServerIntegration): Integration {
        return {
            company,
            name,
            templateUid: template_uid,
            templateName: template_name,
            owner,
            uid,
            link,
            groups: invitation_group,
            createPublicUrl: create_public_url,
            createdOn: created_on,
            modifiedOn: modified_on,
            lastReservationsChecked: last_reservations_checked,
            canForceSync: can_force_sync,
            syncStatus: sync_status,
            syncError: sync_error,
            lastSyncAt: last_sync_at,
            apikeyIsValid: apikey_is_valid,
            hasApiSecret: has_api_secret,
            host_id,
            apikey,
            hotel_id,
            host_name,
            room_id,
            room_name,
            check_in,
            check_out,
            username,
            sendInvitationURL: send_invitation_url,
            sendInvitationURLFromPMS: send_invitation_url_from_pms,
            daysForInvitationCreate: days_for_invitation_create
        };
    }

    static localToServer({ 
        company, 
        name,
        link, 
        groups, 
        createPublicUrl, 
        uid,
        host_id,
        apikey,
        apiSecret,
        handler_url,
        hotel_id,
        host_name,
        room_id,
        room_name,
        check_in,
        check_out,
        username,
        password,
        sendInvitationURL,
        sendInvitationURLFromPMS,
        daysForInvitationCreate,
    }: Integration): ServerIntegrationSend {
        return {
            company,
            name,
            link,
            ...(!!groups && {invitation_group: groups.map(({ id }) => id)}),
            create_public_url: createPublicUrl,
            ...(!!uid && { uid }),
            host_id,
            apikey,
            ...(apiSecret !== undefined && { api_secret: apiSecret }),
            handler_url,
            hotel_id,
            host_name,
            room_id,
            room_name,
            check_in,
            check_out,
            username,
            password,
            send_invitation_url: sendInvitationURL,
            send_invitation_url_from_pms: sendInvitationURLFromPMS,
            days_for_invitation_create: daysForInvitationCreate
        }
    }
}
export class IntegrationReservationMapper {
    static allServerToLocal(serverIntegrations: ServerReservation[]) {
        return serverIntegrations.map(this.serverToLocal);
    }

    static serverToLocal({ status, reservation_end, reservation_id, reservation_start, email, uid, created_on, modified_on, id, integration }: ServerReservation): Reservation {
        return { id, integration, status, uid, email, reservationEnd: reservation_end, reservationStart: reservation_start, reservationId: reservation_id, createdOn: created_on, modifiedOn: modified_on };
    }

}

